var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-layout flex-column hp-10" },
    [
      _c("preloader", {
        staticClass: "preloader prelative",
        attrs: { display: _vm.loading, background: false }
      }),
      _vm._v(" "),
      _c("header", { staticClass: "flex-level mb-4 h-4" }, [
        _vm.$slots["header"] != "" || _vm.metaTitle != ""
          ? _c(
              "h1",
              { staticClass: "m-0" },
              [_vm._t("header", [_vm._v(_vm._s(_vm.metaTitle))])],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "flex-right" }, [
          _c(
            "ul",
            { staticClass: "action-nav" },
            [
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasKpis,
                      expression: "hasKpis"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-level" },
                    [
                      _c("p", { staticClass: "m-0 mr-2" }, [
                        _vm._v(
                          _vm._s(_vm.$l10n.__("Afficher les statistiques"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("CompassSwitch", {
                        attrs: { value: _vm.displayKpi, size: "medium" },
                        on: { click: _vm.toggleKPI }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.enableExport
                ? _c(
                    "li",
                    [
                      _c(
                        "el-dropdown",
                        { attrs: { placement: "bottom-end" } },
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__("common.labels.actions"),
                              type: "secondary",
                              dropdown: ""
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _vm._l(_vm.exportFormats, function(exportFormat) {
                                return [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      class: {
                                        disable: !_vm.permissions.export
                                      }
                                    },
                                    [
                                      _vm.permissions.export
                                        ? _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  _vm.$store.commit(
                                                    _vm.listinghash +
                                                      "/toggleDisplay",
                                                    "export"
                                                  )
                                                  _vm.$store.commit(
                                                    _vm.listinghash +
                                                      "/updateExportType",
                                                    exportFormat
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$l10n.__(
                                                      "Export " +
                                                        exportFormat.toUpperCase()
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$store.dispatch(
                                                    _vm.listinghash +
                                                      "/permissionDenied"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$l10n.__(
                                                      "Export " +
                                                        exportFormat.toUpperCase()
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                ]
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.secondaryButtons, function(button) {
                                return _c(
                                  "el-dropdown-item",
                                  {
                                    key: button.label,
                                    class: { disable: button.disabled }
                                  },
                                  [
                                    button.disabled
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.$store.dispatch(
                                                  _vm.listinghash +
                                                    "/permissionDenied"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(button.label) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      : button.event != undefined
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.$emit(button.event)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(button.label) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "a",
                                          {
                                            attrs: { href: button.href },
                                            on: {
                                              click: function($event) {
                                                button.click != undefined
                                                  ? button.click
                                                  : ""
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(button.label) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.primaryButtons, function(button) {
                return _c(
                  "li",
                  { key: button.label },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t.__(
                            "common.labels.no_necessary_rights"
                          ),
                          placement: "top",
                          disabled: !button.disabled
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "wrapper" },
                          [
                            button.type == "vuejs"
                              ? _c("CompassButton", {
                                  attrs: {
                                    label: button.label,
                                    disabled: button.disabled
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.callBus(
                                        button.url.event,
                                        button.disabled,
                                        {
                                          linkedid: button.linkedid,
                                          linkedtype: button.linkedtype
                                        }
                                      )
                                    }
                                  }
                                })
                              : button.type == "function"
                              ? _c("CompassButton", {
                                  attrs: {
                                    label: button.label,
                                    disabled: button.disabled
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handle_function_call(
                                        button.url.event,
                                        {
                                          linkedid: button.linkedid,
                                          linkedtype: button.linkedtype
                                        },
                                        button.disabled
                                      )
                                    }
                                  }
                                })
                              : button.event != undefined
                              ? _c("CompassButton", {
                                  attrs: {
                                    label: button.label,
                                    disabled: button.disabled,
                                    "data-bot": button.databot
                                      ? button.databot
                                      : ""
                                  },
                                  on: {
                                    click: function($event) {
                                      button.disabled
                                        ? null
                                        : _vm.$emit(button.event)
                                    }
                                  }
                                })
                              : _c("CompassButton", {
                                  attrs: {
                                    label: button.label,
                                    disabled: button.disabled
                                  },
                                  on: {
                                    click: function($event) {
                                      button.disabled
                                        ? null
                                        : _vm.goToUrl(_vm.getButtonHref(button))
                                    }
                                  }
                                })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "listing prelative flex-column ov-reset mh-0 flex" },
        [
          _vm.displayKpi
            ? _c("kpi-list", {
                staticClass: "kip-list",
                attrs: {
                  kpis: _vm.kpis,
                  type: "listing",
                  source: _vm.linkedtype || _vm.name
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "listing-tools flex-level no-shrink mb-2" },
            [
              _c(
                "div",
                { staticClass: "flex flex-level flex-top" },
                [
                  _vm.enableFiltering
                    ? _c("CompassButton", {
                        attrs: { label: _vm.$t.__("common.actions.filter") },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$store.dispatch(
                              _vm.listinghash + "/toggleDisplay",
                              "filters"
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.display.filters
                    ? _c("filters-preview", {
                        attrs: { listinghash: _vm.listinghash }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isMap
                ? _c("paginator", {
                    attrs: { pagination: _vm.pagination },
                    on: { "pagination:update": _vm.goToPage }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.enableOptions && !_vm.isMap
                ? _c(
                    "el-dropdown",
                    { attrs: { placement: "bottom-end" } },
                    [
                      _c("CompassIconButton", {
                        attrs: { icon: "settings-fill", size: "small" }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function($event) {
                                    return _vm.$store.commit(
                                      _vm.listinghash + "/toggleDisplay",
                                      "table"
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$l10n.__("Gestion des lignes"))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-dropdown-item", [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function($event) {
                                    return _vm.$store.commit(
                                      _vm.listinghash + "/toggleDisplay",
                                      "columns"
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$l10n.__("Gestion des colonnes"))
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.switchDisplay && _vm.switchDisplay.length > 0
                ? _c(
                    "CompassToggleButtonGroup",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        value: _vm.activeToggleButton,
                        exclusive: "",
                        size: "small"
                      }
                    },
                    _vm._l(_vm.switchDisplay, function(
                      switchButton,
                      switchIndex
                    ) {
                      return _c(
                        "CompassTooltip",
                        {
                          key: switchIndex,
                          attrs: { content: switchButton.label, arrow: false }
                        },
                        [
                          _c("CompassToggleButton", {
                            attrs: {
                              value: switchButton.id,
                              icon: switchButton.icon,
                              "data-upsell":
                                switchButton.id === "map-view"
                                  ? "map_listing"
                                  : undefined
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.handle_function_call(
                                  switchButton.action,
                                  switchButton.id,
                                  switchButton.selected
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-row mh-0 flex" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.display.filters && _vm.enableFiltering,
                      expression: "display.filters && enableFiltering"
                    }
                  ],
                  staticClass: "leftpane well well-no-shadow mr-4 flex-column"
                },
                [
                  !_vm.filtersComponent
                    ? _c("filters-pane", {
                        attrs: { listinghash: _vm.listinghash }
                      })
                    : _c("company-directory-filters", {
                        attrs: {
                          data: _vm.params,
                          listinghash: _vm.listinghash
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  _vm.display.columns
                    ? _c("listing-columns", {
                        attrs: { listinghash: _vm.listinghash }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  _vm.display.table
                    ? _c("listing-display", {
                        attrs: { listinghash: _vm.listinghash }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "listingContainer br flex flex-column" },
                [
                  _vm.alert.enabled &&
                  !!_vm.alert.text &&
                  _vm.alert.text.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "placeholder-alert placeholder primary-05-bkg b-1-primary-10 p-0 mb-2"
                        },
                        [
                          _c("p", { staticClass: "m-0 fs-3 aleft pl-3" }, [
                            _vm._v(_vm._s(_vm.alert.text))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMap &&
                  !_vm.error &&
                  !_vm.loading &&
                  _vm.enableFiltering &&
                  Object.keys(_vm.rows).length == 0
                    ? _c(
                        "div",
                        { staticClass: "placeholder" },
                        [
                          _c("p", { staticClass: "acenter" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Aucun résultat ne correspond aux filtres appliqués"
                                  )
                                ) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: { label: _vm.$t.__("common.actions.reset") },
                            on: {
                              click: function($event) {
                                return _vm.$store.dispatch(
                                  _vm.listinghash + "/resetListing"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.error &&
                  !_vm.loading &&
                  !_vm.enableFiltering &&
                  Object.keys(_vm.rows).length == 0
                    ? _c("div", { staticClass: "placeholder" }, [
                        _c("p", { staticClass: "acenter" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.emptyResultPlaceholder) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.error
                    ? _c(
                        "div",
                        { staticClass: "placeholder" },
                        [
                          _c("p", { staticClass: "acenter" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Une erreur est survenue, veuillez réinitialiser la liste des filtres"
                                  )
                                ) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: { label: _vm.$t.__("common.actions.reset") },
                            on: {
                              click: function($event) {
                                return _vm.$store.dispatch(
                                  _vm.listinghash + "/resetListing"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMap && Object.keys(_vm.rows).length > 0
                    ? _c("listing-table-element", {
                        ref: "listingTable",
                        attrs: {
                          listinghash: _vm.listinghash,
                          rows: _vm.rows,
                          columns: _vm.activeColumns
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMap && !_vm.error
                    ? _c("listing-map", {
                        attrs: {
                          centermap: _vm.centermap,
                          rows: _vm.rows,
                          maptoken: _vm.maptoken,
                          listinghash: _vm.listinghash
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.display.favoritesForm
            ? _c("listing-favoritesform", {
                attrs: {
                  listinghash: _vm.listinghash,
                  "favorite-data": _vm.favoriteData
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.display.export
            ? _c("export-modal", {
                attrs: {
                  listinghash: _vm.listinghash,
                  "export-type": _vm.display.exportType,
                  "export-options": _vm.exportOptions,
                  "has-kpis": _vm.hasKpis && _vm.enableKpisOnExport
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }